import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

import "../css/HeroSection.css";
import "../css/webflow.css";
import "../css/normalize.css";
import "../css/manmade-cycle-main.webflow.css";
import repairDashboard from "../images/repair dashboard.png"; // Adjust the path as needed

import fashion from "../images/fashion.png";
import electronics from "../images/electronics.png";
import jewellery from "../images/jewellery.svg";
import pokemoncard from "../images/pokemoncard.png";
import figurines from "../images/figurines.png";



const HeroSection = () => {
 const cards = [
  { src: pokemoncard,  },
  { src: electronics,  },
  { src: figurines, },
  { src: fashion, },
  { src: jewellery, },


];


  return (
    <div id="main-section-edit" className="main-section-header-title">
      <section className="section-intro">
        <div className="w-layout-blockcontainer container-3 w-container">
          <h1 className="heading-2">
            Next generation <span className="gradeint-header">Trade-in</span>{" "}
            <br />
            software for all collectibles
          </h1>
          <div className="w-layout-blockcontainer container-5 w-container">
            <div className="div-block-6">
              <img
                src="https://cdn.prod.website-files.com/648422913bdb661f6232a4c4/669e56eeb1d5f08a90d47d7d_Icon.svg"
                loading="lazy"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="text-block">
          Manage your wholesale and direct-to-consumer <br /> business in one
          place.
        </div>
      </section>

      <div className="div-block-2"></div>

      <form className="email-signup-form">
        <div className="input-button-container">
          <input
            type="email"
            placeholder="Enter your email"
            className="email-input custom-input custom-button"
          />

          <Link
            to="/sign-up-today"
            type="button"
            className="btn btn-primary custom-button"
            style={{ backgroundColor: "#3B2B52", color: "white" }}
          >
            Get Free Trial
          </Link>
        </div>
      </form>

      <div className="div-block-4"></div>

      {/* Cards Section (Desktop + Mobile Carousel) */}
      <div className="cardsWrapper">
        {/* Desktop view */}
        <div className="desktopCards">
          {cards.map((card, index) => (
            <div key={index} className="cardItem">
              <img src={card.src} alt={card.label} />
              <p>{card.label}</p>
            </div>
          ))}
        </div>

        {/* Mobile view - Swiper carousel */}
        <div className="mobileCards">
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            style={{ paddingBottom: '24px' }}
          >
            {cards.map((card, index) => (
              <SwiperSlide key={index}>
                <div className="cardItem">
                  <img src={card.src} alt={card.label} />
                  <p>{card.label}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* <div className="div-block-3"></div> */}
    </div>
  );
};

export default HeroSection;
